module.exports = __webpack_public_path__ + "static/media/feature-4-complete-suite.acb6e017.png";